var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentHome'),_c('HomeSegmentA'),_c('HomeSegmentB'),_c('HomeSegmentC'),_c('HomeSegmentE'),_c('white-label'),_c('HomeSegmentD'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }